import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Layout from "../layout/Layout";
import { toCurrency } from "../utils/Convert";
import { api } from "../utils/Api";
import { CSVLink } from "react-csv";
import { FilePdfFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import {
	Button,
	Col,
	Row,
	Statistic,
	Typography,
	DatePicker,
	Select,
	Flex,
} from "antd";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { franchiseOptions } from "../../constants/Customer";
const { Text } = Typography;

const DailySales = ({ history }) => {
	const [invoiceList, setInvoiceList] = useState([]);
	const [loading, setLoading] = useState(true);
	const [dailySale, setDailySale] = useState(0);
	const [selectedDate, setSelectedDate] = useState(dayjs());
	const [plantOptions, setPlantOptions] = useState([]);
	const [subplantOptions, setSublantOptions] = useState([]);
	const [plant, setPlant] = useState("All");
	const [subplant, setSubplant] = useState("All");
	const [franchise, setFranchise] = useState("57Concrete");
	const [loadingSubplant, setLoadingSubplant] = useState(true);
	const refDownload = useRef();

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Invoice",
			dataIndex: "invoice",
			key: "invoice",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Invoice Number",
			dataIndex: "invoiceNumber",
			key: "invoiceNumber",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "mixDesign",
			key: "mixDesign",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Franchise",
			dataIndex: "franchise",
			key: "franchise",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total Yards",
			dataIndex: "yards",
			key: "yards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Unit Price",
			dataIndex: "unitPrice",
			key: "unitPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						prefix={"$"}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Subtotal",
			dataIndex: "subtotal",
			key: "subtotal",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						prefix={"$"}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Tax",
			dataIndex: "tax",
			key: "tax",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						prefix={"$"}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Total",
			dataIndex: "total",
			key: "total",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						prefix={"$"}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return (
					<Button
						type="primary"
						size="large"
						icon={<FilePdfFilled twoToneColor={"white"} />}
						onClick={(e) => history.push(`/invoicepdf/${record.id}`)}
					/>
				);
			},
		},
	];

	useEffect(() => {
		getPlants();
	}, []);

	useEffect(() => {
		getInvoices();
	}, [selectedDate, plant, subplant, franchise]);

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let plantList = [
				{
					label: "All",
					value: "All",
				},
			];
			data.payload.map((item) => {
				plantList.push({
					label: item.name,
					value: item._id,
				});
			});
			setPlantOptions(plantList);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getSublants = async (currentPlant) => {
		const url = api + `/plant/${currentPlant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let subplantList = [
				{
					label: "All",
					value: "All",
				},
			];
			data.subplants.map((item) => {
				subplantList.push({
					label: item.name,
					value: item.name,
				});
			});
			setSublantOptions(subplantList);
			setLoadingSubplant(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getInvoices = async () => {
		setLoading(true);
		const start = `${selectedDate.year()}-${
			selectedDate.month() + 1
		}-${selectedDate.date()}`;
		const end = `${selectedDate.year()}-${
			selectedDate.month() + 1
		}-${selectedDate.date()}`;

		const url =
			api +
			`/invoice/list/dates/${franchise}?startDate=${start}&endDate=${end}&plant=${plant}&subplant=${subplant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			const total = data.reduce((acc, venta) => acc + venta.amount, 0);
			let list = [];
			data.map((item) => {
				list.push({
					key: item._id,
					id: item._id,
					invoice: dayjs(new Date(item.invoiceDate)).format("MM/DD/YYYY"),
					invoiceNumber: item.invoiceNumber,
					customer: item.customer.customerNumber + " " + item.customer.name,
					mixDesign: item.psi,
					unitPrice: item.job.unitPrice,
					yards: item.quantity,
					subtotal: item.amount,
					tax: item.taxAmount,
					total: item.invoiceTotal,
					franchise: item.job.franchise || "57Concrete",
				});
			});
			setInvoiceList(list);
			setDailySale(total);
			setLoading(false);
		} catch (err) {
			console.error(err);
			return null;
		}
	};

	const RenderInvoice = () => {
		return (
			<Row gutter={16}>
				<Col span={24}>
					<h3>Total Sale without taxes: {toCurrency(dailySale, 2)}</h3>
				</Col>
				<Col span={24}>
					<CustomTable
						columns={columns}
						data={invoiceList}
						loading={loading}
						isScroll={false}
					/>
				</Col>
			</Row>
		);
	};

	const onChangePlant = (value) => {
		setLoadingSubplant(true);
		setPlant(value);
		setSubplant("All");
		getSublants(value);
	};

	const onChangeSubplant = (value) => {
		setSubplant(value);
	};

	const onChangeFranchise = (value) => {
		setFranchise(value);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const RenderSearch = () => {
		return (
			<Row gutter={16}>
				<Col span={6}>
					<Text strong>Date</Text>
					<DatePicker
						value={selectedDate}
						onChange={(e) => setSelectedDate(e)}
						allowClear={false}
						format={"MM/DD/YYYY"}
						size="large"
						style={{ width: "100%" }}
					/>
				</Col>
				<Col span={6}>
					<Text strong>Plant</Text>
					<Select
						showSearch
						placeholder={`Select plant`}
						optionFilterProp="children"
						size="large"
						filterOption={filterOption}
						options={plantOptions}
						onChange={onChangePlant}
						value={plant}
						style={{
							width: "100%",
						}}
					/>
				</Col>
				<Col span={6}>
					<Text strong>Sublant</Text>
					<Select
						showSearch
						placeholder={`Select subplant`}
						optionFilterProp="children"
						size="large"
						filterOption={filterOption}
						options={subplantOptions}
						disabled={loadingSubplant}
						onChange={onChangeSubplant}
						value={subplant}
						style={{
							width: "100%",
						}}
					/>
				</Col>
				<Col span={6}>
					<Text strong>Franchise</Text>
					<Select
						showSearch
						placeholder={`Select franchise`}
						optionFilterProp="children"
						size="large"
						onChange={onChangeFranchise}
						filterOption={filterOption}
						options={franchiseOptions}
						disabled={loading}
						value={franchise}
						style={{
							width: "100%",
						}}
					/>
				</Col>
			</Row>
		);
	};

	const headers = () => {
		return columns.slice(0, -1).map((item) => {
			return {
				key: item.key,
				label: item.title,
			};
		});
	};

	const RenderDownloadReport = () => {
		return (
			<div>
				<CSVLink
					data={invoiceList}
					headers={headers()}
					filename={"57concrete-dailysales-report.csv"}
					hidden
					ref={refDownload}
				>
					Download report
				</CSVLink>
				<Row gutter={16}>
					<Col span={24}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={(e) => refDownload.current.link.click()}
							loading={loading}
							size="large"
						>
							Download Report
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	return (
		<Layout title="Daily Sales" description="Sale List">
			<Flex gap={8} vertical>
				<RenderSearch />
				<RenderDownloadReport />
				{loading ? <CustomSpinner /> : <RenderInvoice />}
			</Flex>
		</Layout>
	);
};

export default DailySales;
